module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paginationlayout"
  }, [_c('div', {
    staticClass: "paginationlayout__left"
  }, [_vm._t("left")], 2), _c('div', {
    staticClass: "paginationlayout__center"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "paginationlayout__right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b349bdec","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/listlayout/PaginationLayout.vue
// module id = a5c32380932558b82f03
// module chunks = 0